import type { ReactNode } from "react";

import logo from "@/assets/habits365greek-logo.png";

/**
 * A full-screen message for a partner who cannot use the portal yet (not open
 * yet, not linked, load error). No prototype board: it carries the same HABITS
 * logo as the partner shell's top bar and no footer, so it reads as the portal.
 */
export function PortalMessage({ title, children, action }: { title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-6 text-center">
      <img src={logo} alt="Habits 365 Greek" className="h-8 object-contain dark:invert dark:brightness-200" />
      <div role="alert" className="flex flex-col items-center gap-3">
        <p className="text-base font-semibold text-foreground">{title}</p>
        {children ? <p className="max-w-sm text-sm text-muted-foreground">{children}</p> : null}
        {action}
      </div>
    </div>
  );
}
